// libs
import React, { memo } from 'react';

// components
import Confirmation from './components/Confirmation';

// styles
import { OverlaySheet } from './styles';

// constants
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet';
const NAV_KEY = 'MWEB_CONFIRM_REDIRECT';

// defs
interface ConfirmRedirectProps {
  onConfirm: VoidFunction;
  onCancel: VoidFunction;
  onHide: VoidFunction;
}

function ConfirmRedirect({ onConfirm, onCancel, onHide }: ConfirmRedirectProps) {
  return (
    <OverlaySheet navKey={NAV_KEY} transitionFrom={SHEET_TRANSITION.BOTTOM} onHide={onHide}>
      <Confirmation onCancel={onCancel} onConfirm={onConfirm} />
    </OverlaySheet>
  );
}

export default memo(ConfirmRedirect);
